import React, { Component } from "react";
import LinearProgress from "../components/LinearProgress";
import {
  RaisedButton,
  FloatingActionButton,
  Paper,
  TextField,
  IconButton,
} from "material-ui";
import ContentAdd from "material-ui/svg-icons/content/add";
import ArrangeIcon from "material-ui/svg-icons/action/reorder";
import DelteOptionIcon from "material-ui/svg-icons/action/delete";

import withFirestorePath from "../components/withFirestorePath";
import {
  arrayMove,
  SortableContainer,
  SortableElement,
} from "react-sortable-hoc";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  toggleStyle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  saveButton: {
    marginTop: 15,
  },
};

const SortableOption = SortableElement(({ value, onRemove }) => (
  <Paper
    style={{
      paddingLeft: 8,
      backgroundColor: "tomato",
      color: "white",
      marginBottom: 8,
      alignContent: "center",
      display: "flex",
      cursor: "pointer",
    }}
  >
    <ArrangeIcon
      color="white"
      style={{ alignSelf: "center", marginRight: 4 }}
    />
    <h4 style={{ flex: 1 }}>
      {value.name}{" "}
      {value.price > 0 ? `( +$${(value.price / 100).toFixed(2)})` : ""}
    </h4>
    <IconButton onClick={onRemove}>
      <DelteOptionIcon color="white" />
    </IconButton>
  </Paper>
));

const SortableOptionList = SortableContainer(({ items, onRemoveItem }) => {
  if (!items) return <div />;
  return (
    <div>
      {items.map((value, index) => (
        <SortableOption
          key={`item-${index}`}
          index={index}
          value={value}
          onRemove={() => onRemoveItem(index, value)}
        />
      ))}
    </div>
  );
});

const AddModifierOption = ({
  name,
  price,
  onChangePrice,
  onChangeName,
  onAdd,
  shouldFocusOnNewModifier,
}) => {
  return (
    <form style={{ display: "flex", alignItems: "center" }} onSubmit={onAdd}>
      <TextField
        hintText="Ketchup"
        value={name}
        onChange={onChangeName}
        floatingLabelText="Name"
        ref={(input) => {
          if (shouldFocusOnNewModifier) input && input.focus();
        }}
        style={{ marginRight: 10, flex: 1 }}
      />
      <TextField
        hintText="1.50"
        value={price / 100}
        onChange={(e) => onChangePrice(parseFloat(e.target.value) * 100)}
        type="number"
        step="0.01"
        style={{ flex: 1 }}
        floatingLabelText="Additional Price"
      />
      <div>
        <FloatingActionButton secondary mini type="submit">
          <ContentAdd />
        </FloatingActionButton>
      </div>
    </form>
  );
};

class EditModifier extends Component {
  state = {
    name: "",
    label: "",
    maxOptions: "",
    minOptions: "",
    submitting: false,
    shouldFocusOnNewModifier: false,
    products: null,
    modifierOptions: [],
    loading: true,
    modifierId: null,
    createMode: false,
    restaurantId: null,
    newModifier: {
      name: "",
      price: "",
    },
  };

  async componentDidMount() {
    const { params, restaurantPath } = this.props;
    const restaurantId = params.restaurantId;
    const modifierId = params.modifierId;

    this.modifierPath = restaurantPath.collection("modifiers");

    if (!modifierId) {
      this.setState({
        createMode: true,
        restaurantId,
        loading: false,
      });
      return;
    }

    try {
      const modifierSnap = await this.modifierPath.doc(modifierId).get();
      const modifier = modifierSnap.data();

      this.setState({
        ...modifier,
        modifierId,
        restaurantId,
        loading: false,
      });
    } catch (e) {
      console.log({ e });
      this.setState({
        loading: false,
      });
    }
  }

  handleSubmit = async () => {
    this.setState({
      submitting: true,
    });

    const {
      modifierId,
      createMode,
      name,
      label,
      maxOptions,
      minOptions,
      submitting,
      products,
      modifierOptions,
    } = this.state;

    const modifier = {
      name,
      label,
      maxOptions,
      minOptions,
      submitting,
      products,
      modifierOptions,
    };

    if (createMode) {
      modifier.createdAt = new Date();
      await this.modifierPath.add(modifier);
    } else {
      modifier.updatedAt = new Date();
      await this.modifierPath.doc(modifierId).update(modifier);
    }

    this.props.router.goBack();
  };

  handleNewModifierPrice = (price) => {
    this.setState({
      newModifier: {
        ...this.state.newModifier,
        price,
      },
    });
  };

  handleNewModifierName = (e) => {
    this.setState({
      newModifier: {
        ...this.state.newModifier,
        name: e.target.value,
      },
    });
  };

  handleAddNewModifier = (e) => {
    e.preventDefault();

    const { name, price } = this.state.newModifier;

    let newState = [{ name, price: price === "" ? 0 : price }];

    if (this.state.modifierOptions) {
      newState = newState.concat(this.state.modifierOptions);
    }

    this.setState({
      modifierOptions: newState,
      shouldFocusOnNewModifier: true,
      newModifier: {
        name: "",
        price: 0,
      },
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const options = [...this.state.modifierOptions];
    options[oldIndex].sort = newIndex;
    options[newIndex].sort = oldIndex;

    this.setState({
      modifierOptions: arrayMove(options, oldIndex, newIndex),
    });
  };

  handleRemoveOption = (index, option) => {
    console.log(`Remove ${index}`);
    this.setState({
      modifierOptions: this.state.modifierOptions.filter(
        (val, i) => i !== index
      ),
    });
  };

  componentDidUpdate() {
    if (this.state.shouldFocusOnNewModifier) {
      this.setState({
        shouldFocusOnNewModifier: false,
      });
    }
  }

  render() {
    const {
      name,
      label,
      maxOptions,
      minOptions,
      submitting,
      products,
      modifierOptions,
      createMode,
      loading,
    } = this.state;

    console.log({ state: this.state });

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h1>{createMode ? "Create Modifier" : "Edit Modifier"}</h1>
        <form style={styles.form}>
          <Paper style={styles.paper}>
            <TextField
              hintText="Toppings"
              value={name}
              onChange={(e) => this.setState({ name: e.target.value })}
              fullWidth
              floatingLabelText="Name"
            />
            <TextField
              value={label}
              onChange={(e) => this.setState({ label: e.target.value })}
              fullWidth
              hintText={`Choose a ${this.state.name}`}
              floatingLabelText="Label"
            />
            <TextField
              hintText="Enter least amount of options user must choose"
              value={minOptions}
              onChange={(e) =>
                this.setState({ minOptions: parseInt(e.target.value) })
              }
              fullWidth
              type="number"
              floatingLabelText="Minimum Options"
            />
            <TextField
              hintText="Enter most amount of options user must choose"
              value={maxOptions}
              onChange={(e) =>
                this.setState({ maxOptions: parseInt(e.target.value) })
              }
              fullWidth
              type="number"
              floatingLabelText="Maximum Options"
            />
          </Paper>
          <h2>Modifier Options</h2>
          <Paper style={styles.paper}>
            <h3>Add new modifier option</h3>
            <AddModifierOption
              name={this.state.newModifier.name}
              price={this.state.newModifier.price}
              onChangePrice={this.handleNewModifierPrice}
              onChangeName={this.handleNewModifierName}
              onAdd={this.handleAddNewModifier}
              shouldFocusOnNewModifier={this.state.shouldFocusOnNewModifier}
            />
            <h3>{modifierOptions.length > 0 ? "Options" : ""}</h3>
            <SortableOptionList
              items={modifierOptions}
              onSortEnd={this.onSortEnd}
              onRemoveItem={this.handleRemoveOption}
            />
          </Paper>
          <RaisedButton
            label="Cancel"
            style={{ marginRight: 8 }}
            onTouchTap={() => this.props.router.goBack()}
          />
          <RaisedButton
            label="Save"
            style={styles.saveButton}
            onTouchTap={this.handleSubmit}
            disabled={submitting}
            secondary
          />
        </form>
      </div>
    );
  }
}

export default withFirestorePath(EditModifier);



// WEBPACK FOOTER //
// ./src/pages/EditModifier.js